import { useEffect, useMemo } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../features/table/helpers';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { useTreeStore } from '../../../../store/use-tree-store';
import { SortType } from '../../../../types/props';
import { defaultViewStyle, viewStyleKey, withArchiveKey } from '../../../../helpers/path';
import { FetchTreeListRequest } from '../../../../store/api/trees-api';

export const useTreeList = () => {
  const { fetchTreeList, isLoadingFetch, restoreTree, deleteTree, list } = useTreeStore();
  const { t } = useLang();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const name = params.name;
  const qr = params.qr;
  const ts = params['ts'];
  const description = params['description'];
  const sort = params[sortKey];
  const branch = params.branch;
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const with_archive = !!params[withArchiveKey];
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  const requestParams: FetchTreeListRequest = useMemo(() => {
    return {
      name,
      qr,
      since_id: 0,
      n: 1000,
      is_by_company: true,
      field: sortField,
      dir: sortDirection,
      description,
      with_archive,
      branch,
    };
  }, [
    description,
    fetchTreeList,
    name,
    qr,
    sortDirection,
    sortField,
    ts,
    with_archive,
    viewStyle,
    branch,
  ]);

  useEffect(() => {
    fetchTreeList(requestParams);
  }, [requestParams]);

  // const handleEnd = () => {
  //   if (isLoadingFetch || !pagination || pagination.is_last) return;
  //   const nextPage = pagination.page + 1;
  //   fetchTreeList({ ...requestParams, page: nextPage, infinite: true });
  // };

  return {
    isLoadingFetch,
    t,
    restoreTree,
    deleteTree,
    list,
    viewStyle,
  };
};
